<template>
  <div class="main-content">

    <!-- 条件查询 -->
    <div>
      <el-form ref="searchForm" :inline="true" :model="searchForm" class="form-content">
        <el-row :gutter="20" :style="{justifyContent:contents.searchBoxPosition==='1'?'flex-start':contents.searchBoxPosition==='2'?'center':'flex-end'}"
                class="slt">

          <el-form-item label="煤炭名称" prop="cocalName">
            <el-input v-model="searchForm.cocalName" clearable placeholder="煤炭名称" prefix-icon="el-icon-search"
                      style="width:200px"></el-input>
          </el-form-item>
          <el-form-item label="煤源类型" prop="cocalType">
            <el-select v-model="searchForm.cocalType" placeholder="煤源类型" style="width:100px">
              <el-option v-for="(item,i) in cocalTypeList" :key="i" :label="item.indexName" :value="item.indexName"
                         clearable></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否破碎" prop="isBroken">
            <el-select v-model="searchForm.isBroken" placeholder="是否破碎" style="width:100px">
              <el-option clearable label="是" value="是"></el-option>
              <el-option clearable label="否" value="否"></el-option>
            </el-select>
          </el-form-item>
          <br/>
          <el-form-item label="热值">
            <el-input v-model="searchForm.startHots" clearable placeholder="起" prefix-icon="el-icon-search"
                      style="width:100px;padding-right:5px"></el-input>
            到
            <el-input v-model="searchForm.endHots" clearable placeholder="至" prefix-icon="el-icon-search"
                      style="width:100px"></el-input>
          </el-form-item>
          <el-form-item label="硫分值">
            <el-input v-model="searchForm.startLiufen" clearable placeholder="起" prefix-icon="el-icon-search"
                      style="width:100px;padding-right:5px"></el-input>
            到
            <el-input v-model="searchForm.endLiufen" clearable placeholder="至" prefix-icon="el-icon-search"
                      style="width:100px"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="success" @click="search()">查询<i class="el-icon-search el-icon--right"/></el-button>
            <el-button type="success" @click="reset()">重置<i class="el-icon-refresh el-icon--right"/></el-button>
          </el-form-item>
        </el-row>
        <el-row :style="{justifyContent:contents.btnAdAllBoxPosition=='1'?'flex-start':contents.btnAdAllBoxPosition=='2'?'center':'flex-end'}"
                class="ad">
          <el-form-item>
            <el-button v-show="isEmporer('新增')" icon="el-icon-plus" type="success" @click="addOrUpdateHandler()">
              新增
            </el-button>
            <el-button v-show="isEmporer('导入')" icon="el-icon-top" type="success" @click="openImportDialog()">导入
            </el-button>
            <el-button v-show="isEmporer('导出')" icon="el-icon-top" type="success">
              <a :href="url+'cocalTemplate/download?companyId='+companyId" style="color:white">导出数据</a>
            </el-button>
            <el-button v-show="isEmporer('删除')" :disabled="this.dataListSelections.length<=0" icon="el-icon-plus" type="danger"
                       @click="mulDel">批量删除
            </el-button>
            <el-button v-if="role.indexOf('管理员')!==-1" icon="el-icon-top" type="success" @click="cocalShare()">
              煤源分享
            </el-button>

            <!-- <el-button
                     :disabled="dataListSelections.length <= 0"
                     type="danger"
                     icon="el-icon-delete"
                     @click="deleteHandler()"
             >删除</el-button>-->
          </el-form-item>
        </el-row>
      </el-form>
      <div class="table-content">
        <el-table v-loading="dataListLoading" :border="contents.tableBorder" :cell-style="cellStyle"
                  :data="dataList" :fit="contents.tableFit"
                  :header-cell-style="headerCellStyle"
                  :header-row-style="headerRowStyle"
                  :height="'800px'"
                  :row-class-name="rowStyle"
                  :show-header="contents.tableShowHeader"
                  :size="contents.tableSize"
                  :stripe="contents.tableStripe"
                  :style="{width: '100%',fontSize:contents.tableContentFontSize,color:contents.tableContentFontColor}"
                  class="tables"
                  @sort-change="hadleSort"
                  @row-dblclick="handleRowDoubleClick"
                  @selection-change="handleSelectionChange"
        >
          <el-table-column :reserve-selection="true" type="selection" width="55"/>
          <el-table-column v-if="contents.tableIndex" fixed label="索引" type="index" width="50"/>
          <!--                    <el-table-column  :sortable="contents.tableSortable" align="center" prop="orgType"  label="类型" fixed></el-table-column>-->
          <el-table-column align="center" fixed label="所属公司" prop="companyName" width="180"></el-table-column>
          <el-table-column align="center" fixed label="煤炭名称" prop="cocalName" width="200">
            <template slot-scope="scope">{{ scope.row.cocalName }}
              <span v-if="scope.row.sourceType==='1'" style="color: #00c292">【系统推荐】系统优惠:
                {{scope.row.sysDiscount}}元
              </span></template>
          </el-table-column>
          <el-table-column align="center" fixed label="联系人" prop="personName1"></el-table-column>
          <el-table-column align="center" fixed label="联系电话" prop="mobile1"></el-table-column>
          <el-table-column align="center" fixed label="煤种类型" prop="cocalType"></el-table-column>
          <el-table-column align="center" label="热值" prop="hots" sortable="custom"></el-table-column>
          <el-table-column align="center" label="硫分" prop="liufen"></el-table-column>
          <el-table-column align="center" label="含税单价" prop="unitPrice" sortable="custom"
                           width="130"></el-table-column>
          <el-table-column align="center" label="是否破碎" prop="isBroken"></el-table-column>
          <el-table-column align="center" label="库存" prop="stock"></el-table-column>
          <el-table-column align="center" label="到场地" prop="arriveStation" width="100"></el-table-column>
          <el-table-column align="center" label="含税运费" prop="hsPrice" sortable="custom"
                           width="100"></el-table-column>
          <el-table-column align="center" label="场地费" prop="stationPrice" sortable="custom"
                           width="90"></el-table-column>


          <el-table-column :align="contents.tableAlign" fixed="right"
                           header-align="center" label="操作"
                           width="300">
            <template slot-scope="scope">
              <el-button v-show="isEmporer('明细')" icon="el-icon-tickets" size="mini" type="success"
                         @click="addOrUpdateHandler(scope.row,'info')">明细
              </el-button>
              <el-button v-show="isEmporer('编辑')" v-if="scope.row.sourceType!=='1'" icon="el-icon-edit" size="mini" type="primary"
                         @click="addOrUpdateHandler(scope.row)">修改
              </el-button>
              <el-button v-show="isEmporer('编辑')" v-if="scope.row.sourceType==='1'" icon="el-icon-edit" size="mini" type="primary"
                         @click="editSystemShare(scope.row)">修改
              </el-button>
              <el-button v-show="isEmporer('删除')" icon="el-icon-delete" size="mini" type="danger"
                         @click="deleteHandler(scope.row.id)">删除
              </el-button>

            </template>
          </el-table-column>
        </el-table>
        <!--                <el-pagination
                                clsss="pages"
                                :layout="layouts"
                                @size-change="sizeChangeHandle"
                                @current-change="currentChangeHandle"
                                :current-page="pageIndex"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="Number(contents.pageEachNum)"
                                :total="totalPage"
                                :small="contents.pageStyle"
                                class="pagination-content"
                                :background="contents.pageBtnBG"
                                :style="{textAlign:contents.pagePosition==1?'left':contents.pagePosition==2?'center':'right'}"
                        ></el-pagination>-->
        <el-pagination
            :current-page="pageIndex"
            :page-size="pageSize"
            :page-sizes="[10, 20, 30, 50, 100]"
            :total="totalPage"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle">
        </el-pagination>
      </div>
    </div>
    <add-or-update :rowData="rowData" :show="addOrUpdateFlag" v-on:listenToChildEvent="closeDialog"></add-or-update>
    <cocal-import :show="importShow" v-on:listenToChildEvent="closeImportDialog"></cocal-import>
<!--    <cocal-share-dialog :rowData="shareRowData" :show="shareShow"
                        v-on:listenToChildEvent="closeShareDialog"></cocal-share-dialog>-->
    <cocal-share-edit :rowData="shareEditData" :show="shareEditFlag" v-on:listenToChildEvent="closeShareEditDialog"></cocal-share-edit>
    <cocal-share-dialog-new :rowData="shareRowData" :show="shareShow"
                        v-on:listenToChildEvent="closeShareDialog"></cocal-share-dialog-new>
  </div>
</template>
<script>
import AddOrUpdate from "./add-or-update";
import cocalImport from "./cocal-import";
import cocalShareDialog from "./cocal-share-dialog";
import cocalShareDialogNew from "./cocal-share-dialog-new";
import cocalShareEdit from "./cocal-share-edit.vue";
import styleJs from "../../../utils/style.js";
import base from '@/utils/base';

export default {
  data() {
    return {
      shareEditFlag: false,
      shareEditData: {},
      selectedRow: {},
      shareShow: false,
      shareRowData: {},
      url: base.get().url,
      importShow: false,
      //打印结束
      searchForm: {
        key: ""
      },
      sessionTable: "",//登录账户所在表名
      role: "",//权限
      userId: "",//当前登录人的id
      //级联表下拉框搜索条件
      //当前表下拉框搜索条件
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      showFlag: true,
      addOrUpdateFlag: false,
      contents: null,
      layouts: '',
      rowData: {},
      cocalTypeList: [],
      sort: 'id',
      order: 'desc',
      selectBtnStr: '',
      menuBtnList: [],
      companyId: '',
    };
  },
  created() {
    window.vm = this;
    this.contents = styleJs.listStyle();
    this.init();
    this.initCocalTypeList();
    this.getDataList();
    let btnList = this.$storage.getMenuBtnListByMenuName("cocalTemplate");
    this.selectBtnStr = btnList;
    this.initBtnList();
    this.companyId = this.$storage.get("companyId");
  },
  mounted() {
    //获取当前登录用户的信息
    this.sessionTable = this.$storage.get("sessionTable");
    this.role = this.$storage.get("role");
    this.userId = this.$storage.get("userId");

  },
  filters: {
    htmlfilter: function (val) {
      return val.replace(/<[^>]*>/g).replace(/undefined/g, '');
    }
  },
  components: {
    AddOrUpdate,
    cocalImport,
    cocalShareDialog,
    cocalShareEdit,
    cocalShareDialogNew
  },
  computed: {},
  methods: {
    closeShareEditDialog(){
      this.shareEditFlag = false;
      this.shareEditData = {};
      this.getDataList();
    },
    editSystemShare(rowData){
      this.shareEditFlag = true;
      this.shareEditData = rowData;
    },
    mulDel() {
      let ids = this.dataListSelections.map(item => {
        return item.id
      })
      this.$confirm(`确定对进行批量删除操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: 'cocalTemplate/delete',
          method: 'post',
          data: ids
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList();
              }
            })
          } else {
            this.$message.error(data.msg);
          }
        })
      })
    },
    handleSelectionChange(val) {
      this.dataListSelections = val;
    },
    // 表格
    rowStyle({row, rowIndex}) {
      if (row.sourceType==='1'){
        return 'success-row';
      }
    },
    cellStyle({row, rowIndex}) {
      if (rowIndex % 2 == 1) {
        if (this.contents.tableStripe) {
          return {backgroundColor: this.contents.tableStripeBgColor}
        }
      } else {
        return ''
      }
    },
    headerRowStyle({row, rowIndex}) {
      return {color: this.contents.tableHeaderFontColor}
    },
    headerCellStyle({row, rowIndex}) {
      return {backgroundColor: this.contents.tableHeaderBgColor}
    },
    // 表格按钮
    contentTableBtnStyleChange() {
    },
    // 分页
    contentPageStyleChange() {
      let arr = []
      if (this.contents.pageTotal) arr.push('total')
      if (this.contents.pageSizes) arr.push('sizes')
      if (this.contents.pagePrevNext) {
        arr.push('prev')
        if (this.contents.pagePager) arr.push('pager')
        arr.push('next')
      }
      if (this.contents.pageJumper) arr.push('jumper')
      this.layouts = arr.join()
      this.contents.pageEachNum = 10
    },

    init() {
    },
    hadleSort({column, prop, order}) {
      console.log(`排序字段: ${prop}, 排序方向: ${order}`);
      this.sort = prop.replace(/([A-Z])/g, "_$1").toLowerCase();
      this.order = order.replace("ending", "");
      this.getDataList();
    },
    search() {
      this.pageIndex = 1;
      this.getDataList();
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      let params = {
        page: this.pageIndex,
        limit: this.pageSize,
        sort: this.sort,
        order: this.order
      }
      if (this.searchForm.cocalName !== '' && this.searchForm.cocalName !== undefined) {
        params['cocalName'] = '%' + this.searchForm.cocalName + '%'
      }
      if (this.searchForm.cocalType !== '' && this.searchForm.cocalType !== undefined) {
        params['cocalType'] = '%' + this.searchForm.cocalType + '%'
      }
      if (this.searchForm.isBroken !== '' && this.searchForm.isBroken !== undefined) {
        params['isBroken'] = '%' + this.searchForm.isBroken + '%'
      }
      if (this.searchForm.startHots !== '' && this.searchForm.startHots !== undefined) {
        params['startHots'] = this.searchForm.startHots;
      }
      if (this.searchForm.endHots !== '' && this.searchForm.endHots !== undefined) {
        params['endHots'] = this.searchForm.endHots;
      }
      if (this.searchForm.startLiufen !== '' && this.searchForm.startLiufen !== undefined) {
        params['startLiufen'] = this.searchForm.startLiufen;
      }
      if (this.searchForm.endLiufen !== '' && this.searchForm.endLiufen !== undefined) {
        params['endLiufen'] = this.searchForm.endLiufen;
      }
      this.$http({
        url: "cocalTemplate/page",
        method: "get",
        params: params
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.dataList = data.data.list;
          this.totalPage = data.data.total;
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
      });

      //查询级联表搜索条件所有列表
      //查询当前表搜索条件所有列表
    },
    //每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandler(val) {
      this.dataListSelections = val;
    },
    // 添加/修改
    addOrUpdateHandler(row, type) {
      this.addOrUpdateFlag = true;
      if (row != undefined) {
        row.type = type;
        this.rowData = row;
      }
    },
    // 删除
    deleteHandler(id) {
      var ids = id ? [Number(id)] : this.dataListSelections.map(item => {
        return Number(item.id);
      });

      this.$confirm(`确定进行[${id ? "删除" : "批量删除"}]操作?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http({
          url: "cocalTemplate/delete",
          method: "post",
          data: ids
        }).then(({data}) => {
          if (data && data.code === 0) {
            this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500,
              onClose: () => {
                this.search();
              }
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    },
    closeDialog() {
      this.addOrUpdateFlag = false;
      this.getDataList();
    },
    formatDate(dateStr) {
      let date = new Date(dateStr);
      return date.toLocaleString();
    },
    closeImportDialog() {
      this.importShow = false;
      this.getDataList();
    },
    openImportDialog() {
      this.importShow = true;
    },
    initCocalTypeList() {
      let params = {
        page: 1,
        limit: 30,
        sort: 'id',
      }
      params['dicCode'] = "cocal_type"//编码名字
      params['dicName'] = "煤种类型",//汉字名字
          this.$http({
            url: "dictionary/page",
            method: "get",
            params: params
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.cocalTypeList = data.data.list;
            }
          });
    },
    reset() {
      this.$refs['searchForm'].resetFields();
      this.sort = 'id';
      this.order = 'desc';
      this.searchForm.startHots = '';
      this.searchForm.endHots = '';

    },
    initBtnList() {
      let params = {
        page: this.pageIndex,
        limit: 30,
        sort: 'id',
      }
      //本表的
      params['dicCode'] = "menu_types"//编码名字
      params['dicName'] = "按钮类型",//汉字名字
          this.$http({
            url: "dictionary/page",
            method: "get",
            params: params
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.menuBtnList = data.data.list;
            }
          });
    },
    isEmporer(btnName) {
      let menuBtn = this.menuBtnList.find(item => item.indexName == btnName);
      //console.log(btnName+":"+this.selectBtnStr.indexOf(menuBtn.codeIndex)==-1?false:true);
      return this.selectBtnStr.indexOf(menuBtn.codeIndex) !== -1;
    },
    exportData() {
      window.location.href("http://localhost:8080/cocal_dec/cocalTemplate/download");
    },
    cocalShare() {
      if (this.selectedRow.id === undefined) {
        this.$message.error("请双击要分享的数据后，再点击数据分享");
      } else {
        this.shareShow = true;
        this.shareRowData = this.selectedRow;
      }
    },
    closeShareDialog(flag) {
      this.shareShow = false;
      this.shareRowData = {};
      this.selectedRow = {};
    },
    handleRowDoubleClick(row, column, event) {
      console.log(row);
      this.selectedRow = row;
    },


  },

};
</script>
<style lang="scss" scoped>
    .main-content {
        background: #fff;
        border-radius: 6px;
        padding: 20px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    }

    .slt {
        margin: 0 !important;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 0;
        padding-bottom: 12px;
        border-bottom: 1px solid #f0f0f0;
    }

    .ad {
        margin: 0 !important;
        display: flex;
        align-items: center;
        padding: 12px 0;
    }

    .pages {
        & /deep/ el-pagination__sizes {
            & /deep/ el-input__inner {
                height: 28px;
                line-height: 28px;
            }
        }
    }

    .el-button+.el-button {
        margin-left: 8px;
    }

    .form-content {
        background: transparent;
    }

    .table-content {
        background: transparent;
    }

    /* 搜索区按钮 */
    .form-content .slt .el-button--success {
        background-color: var(--publicMainColor);
        border-color: var(--publicMainColor);
        color: #fff;
        border-radius: 4px;
        padding: 10px 20px;
        font-size: 14px;
        transition: all 0.25s ease;

        &:hover {
            background-color: #2b5797;
            border-color: #2b5797;
        }
    }

    /* 新增按钮 */
    .form-content .ad .el-button--success {
        background-color: var(--publicSubColor);
        border-color: var(--publicSubColor);
        color: #fff;
        border-radius: 4px;
        padding: 10px 20px;
        font-size: 14px;
        transition: all 0.25s ease;

        &:hover {
            background-color: #c9602d;
            border-color: #c9602d;
        }
    }

    /* 表格样式 */
    .tables {
        width: 100%;
        border-radius: 4px;
        overflow: hidden;

        & /deep/ .el-table__header th {
            background-color: #f5f7fa;
            color: #303133;
            font-weight: 600;
            font-size: 14px;
        }

        & /deep/ .el-table__body tr {
            background-color: #fff !important;
            color: #606266 !important;
        }

        & /deep/ .el-table__body tr.el-table__row--striped td {
            background: #fafafa;
        }

        & /deep/ .el-table__body tr.el-table__row--striped {
            background-color: #fafafa !important;
            color: #606266 !important;
        }

        & /deep/ .el-table__body tr:hover > td {
            background-color: rgba(58, 110, 165, 0.06) !important;
            color: #303133 !important;
        }

        /* 表格操作按钮 */
        & /deep/ .el-button--success {
            background-color: #67c23a;
            border-color: #67c23a;
            color: #fff;
            border-radius: 4px;
            padding: 7px 15px;
            font-size: 12px;
            border-style: solid;
            border-width: 1px;

            &:hover {
                background-color: #85ce61;
                border-color: #85ce61;
            }
        }

        & /deep/ .el-button--primary {
            background-color: var(--publicMainColor);
            border-color: var(--publicMainColor);
            color: #fff;
            border-radius: 4px;
            padding: 7px 15px;
            font-size: 12px;
            border-style: solid;
            border-width: 1px;

            &:hover {
                background-color: #2b5797;
                border-color: #2b5797;
            }
        }

        & /deep/ .el-button--danger {
            background-color: #f56c6c;
            border-color: #f56c6c;
            color: #fff;
            border-radius: 4px;
            padding: 7px 15px;
            font-size: 12px;
            border-style: solid;
            border-width: 1px;

            &:hover {
                background-color: #f78989;
                border-color: #f78989;
            }
        }

        & /deep/ .el-button--warning {
            background-color: #e6a23c;
            border-color: #e6a23c;
            color: #fff;
            border-radius: 4px;
            padding: 7px 15px;
            font-size: 12px;
            border-style: solid;
            border-width: 1px;

            &:hover {
                background-color: #ebb563;
                border-color: #ebb563;
            }
        }

        & /deep/ .el-button {
            margin: 4px;
        }
    }

    /* 分页 */
    .pagination-content {
        margin-top: 20px;
        padding: 10px 0;
    }

    /* 封面图片 */
    .tables /deep/ img {
        border-radius: 6px;
        object-fit: cover;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
</style>


